// Board search matches the task name only - case-insensitive substring.
// Pass every active query (board level and section level) and they compose with AND.
export const matchesTaskName = (task, ...queries) =>
  queries.every((query) => {
    const term = (query || '').trim().toLowerCase();
    if (!term) return true;
    return (task?.taskName || '').toLowerCase().includes(term);
  });

// True when at least one query is actually filtering, i.e. the view is a subset.
export const hasActiveQuery = (...queries) => queries.some((query) => (query || '').trim().length > 0);
